import { Modal, Stack } from '@mantine/core';
import type { TeamOut } from '@repo/api-codegen';
import { Text } from '@repo/foundations';
import { observer } from 'mobx-react-lite';
import { InviteTeamMemberForm } from '../InviteTeamMemberForm/InviteTeamMemberForm';

interface IInviteTeamMemberModalProps {
	onClose: VoidFunction;
	opened: boolean;
	team: TeamOut;
	onFinish: (teamId: string) => void;
}

export const InviteTeamMemberModal = observer(
	({ onClose, opened, team, onFinish }: IInviteTeamMemberModalProps) => (
		<Modal
			opened={opened}
			onClose={onClose}
			title={null}
			size={480}
			withCloseButton={false}
			top={150}
		>
			<Stack spacing="md">
				<Text size="md">
					<Text span>Invite people to</Text>{' '}
					<Text span weight="bold">
						{team.icon} {team.name}
					</Text>
				</Text>
				<InviteTeamMemberForm
					team={team}
					onFinish={onFinish}
					placeholder="Add people or groups"
				/>
			</Stack>
		</Modal>
	)
);
